export default {
  close: {
    id: 'product_page_telco_calculator_modal_close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'product_page_telco_calculator_modal_title',
    defaultMessage: 'Don’t be fooled by a “free” upgrade.',
  },
  section1Title: {
    id: 'product_page_telco_calculator_modal_section1_title',
    defaultMessage: 'Don’t let carriers fool you with “free” phones',
  },
  section1Description: {
    id: 'product_page_telco_calculator_modal_section1_description',
    defaultMessage:
      'What feels like a good deal today can cost you thousands by the end of your contract. See how much you could save by adding your details below.',
  },
  section2Title: {
    id: 'product_page_telco_calculator_modal_section2_title',
    defaultMessage: 'Enter your details',
  },
  summaryTitle: {
    id: 'product_page_telco_calculator_modal_calculator_summary_title',
    defaultMessage: 'Summary',
  },
  savingsTitle: {
    id: 'product_page_telco_calculator_modal_calculator_savings_title',
    defaultMessage: 'Potential savings',
  },
  savingsTelcoTotalCost: {
    id: 'product_page_telco_calculator_modal_calculator_telco_total_cost',
    defaultMessage: 'Total cost',
  },
  savingsBMTotalCost: {
    id: 'product_page_telco_calculator_modal_calculator_bm_total_cost',
    defaultMessage: 'Total cost Back Market',
  },
  savingsBMPlan: {
    id: 'product_page_telco_calculator_modal_calculator_bm_plan',
    defaultMessage: 'With an unlimited $25/month plan',
  },
  savings: {
    id: 'product_page_telco_calculator_modal_calculator_savings',
    defaultMessage: 'Your savings',
  },
  detailsTitle: {
    id: 'product_page_telco_calculator_modal_calculator_details_title',
    defaultMessage: 'See calculation details',
  },
  detailsDescription: {
    id: 'product_page_telco_calculator_modal_calculator_details_description',
    defaultMessage:
      '“Potential savings” is estimated based on your selected device on Back Market vs. carrier plan prices for new iPhone 17 upgrades collected December 2025. The “Total cost Back Market” is a $25/month BYOD plan plus your selected device price multiplied by contract length. Actual prices, taxes/fees and savings vary by seller, plan, location and eligibility.',
  },
}
